import * as React from 'react';
import { ArticleListOverview } from '../../../amorg-common';
import { getArticleListOverview } from '../../../api/siteArticlesClientApi';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Icon } from '../../../designSystem/icons/Icons';
import { P } from '../../../designSystem/typography/Body';
import { H3 } from '../../../designSystem/typography/Heading';
import { DashboardCard } from './DashboardCard';


export function DashboardArticleCard(): JSX.Element {

    const [totalListCount, setTotalListCount] = React.useState<number | null>(null);
    const [totalSubscriptionCount, setTotalSubscriptionCount] = React.useState<number | null>(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const listing = await getArticleListOverview();
            const data = listing as ArticleListOverview;
            
            const totalSubscriptions = data?.lists.reduce((acc, list) =>
                acc + (list.topics || []).reduce((s, t) => s + (t.articleCount || 0), 0)
                , 0);

            const totalLists = (data?.lists || []).filter(list =>
+                (list.topics || []).some(topic => (topic.articleCount ?? 0) > 0)
            ).length;
            setTotalListCount(totalLists);

            setTotalSubscriptionCount(totalSubscriptions || 0);
         
            setLoading(false);
        };
        getData();

    }, []);


    if (!loading) {
    return (
        
        <DashboardCard backgroundColor="white">
            <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
                <H3>Lovservice</H3>
                <Icon name="balance" color="black" />
            </Flex>
            <P>Vi overvåger {totalSubscriptionCount} lovkrav for Jer i {totalListCount} lister</P>
            
        </DashboardCard>
    ) } else {
        return (
            <DashboardCard backgroundColor="white">
                <H3>Lovservice</H3>
                <P>Indlæser...</P>
            </DashboardCard>
        );
    }
}
